exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popper-class .title-item[data-v-2d2bbdc2] {\n  overflow: hidden;\n  width: auto;\n  font-size: 0.875rem;\n  font-weight: inherit;\n  margin: 0 auto;\n}\n.title-item[data-v-2d2bbdc2] {\n  overflow: hidden;\n  width: 1.75rem;\n  font-size: 0.875rem;\n  font-weight: bold;\n  margin: 0 auto;\n}", ""]);

// exports
